import React from "react";

const Surface = React.forwardRef(({
  raised,
  elevated,
  level,
  outline,
  shape,
  margin,
  padding,
  className,
  id,
  style,
  children,
  ...rest
}, ref) => {
  const classes = [
    "ta-surface",
    raised && "ta-elevation_shadow-" + level,
    elevated && "ta-elevation_shadow-" + elevated,
    shape && "ta-shape_radius-" + shape,
    margin && "ta-margin_" + margin,
    padding && "ta-padding_" + padding,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      ref={ref}
      id={id}
      className={classes}
      style={style}
      data-variant={outline === "variant" ? "outlinevariant" : outline ? "outline" : undefined}
      data-level={level !== undefined ? level : undefined}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Surface;
